module.exports = __webpack_public_path__ + "static/media/iotagriculture.f1244c86.jpg";